(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[318],{

/***/ 71070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos",
      function () {
        return __webpack_require__(99433);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 99433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ TrainingListing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
;// CONCATENATED MODULE: ./src/domain/Training/TrainingListingCard.js



function TrainingListingCard(param) {
    var uri = param.uri, title = param.title, excerpt = param.excerpt, _details = param.details, color = _details.color, certification = _details.certification;
    var hasCertification = certification !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        className: "transition ease-in-out duration-500 transform hover:-translate-y-1 rounded-lg lg:rounded-xl xl:rounded-2xl shadow-lg hover:shadow-outside-lg flex w-full ring-1 ring-black ring-opacity-10 hover:ring-opacity-20",
        href: uri,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col rounded-lg lg:rounded-xl xl:rounded-2xl w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white divide-y-2 divide-gray-100 rounded-t-lg lg:rounded-t-xl xl:rounded-t-2xl overflow-hidden flex-1 w-full relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center text-center md:text-left md:flex-row space-y-6 md:space-y-0 md:space-x-6 px-6 lg:px-8 py-6",
                            children: [
                                hasCertification && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: certification.featuredImage.node.sourceUrl,
                                    alt: certification.title,
                                    width: 150,
                                    height: 150
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col space-y-4 relative z-10 flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "font-semibold text-green-500",
                                                    children: "Entrenamiento"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-2xl lg:text-3xl font-bold lg:font-medium tracking-tight text-gray-900 hover:text-gray-700",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "leading-8 md:leading-9",
                                                        children: title
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center md:justify-start",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-flex items-center space-x-1 leading-4 pl-5 pr-3 py-2 bg-green-500 text-white font-semibold rounded-full hover:bg-green-600 focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 focus:outline-none focus:bg-green-600",
                                                tabIndex: "-1",
                                                role: "button",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Conocer m\xe1s"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        className: "h-5 w-5",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                                            clipRule: "evenodd"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col space-y-3 px-6 py-4 lg:py-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gray-500 font-medium",
                                dangerouslySetInnerHTML: {
                                    __html: excerpt
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center px-6 py-4 bg-green-500 rounded-b-lg lg:rounded-b-xl xl:rounded-b-2xl relative overflow-hidden",
                    style: {
                        backgroundColor: color
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1 flex-col opacity-70 space-y-1 text-sm font-semibold text-white relative z-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "leading-none",
                                    children: "Asociaci\xf3n"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "leading-none",
                                    children: "Iberoamericana"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "leading-none",
                                    children: "de Scrum"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "w-10 h-10 text-white relative z-10",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "z-0 absolute inset-0 bg-gradient-to-tl from-black to-transparent opacity-20"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/entrenamientos/index.js








var defaultProps = {
    trainings: []
};
var propTypes = {
    trainings: prop_types_default().arrayOf((prop_types_default()).object)
};
var __N_SSG = true;
function TrainingListing(param) {
    var trainings = param.trainings;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-10 bg-white shadow-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative -mb-px flex items-center space-x-4 lg:space-x-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "flex items-center border-b-2 border-green-500 py-4 px-1 font-medium text-green-500",
                                children: "Entrenamientos"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                className: "flex items-center border-b-2 border-transparent py-4 px-1 font-medium text-gray-500 hover:text-gray-900",
                                href: "/certificaciones",
                                children: "Certificaciones"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-10 bg-gray-100 py-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "rounded-lg bg-gray-900 px-4 py-3 text-lg text-gray-100 shadow-lg",
                            role: "alert",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start space-x-3 md:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-1 md:mt-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "h-5 w-5 text-gray-400",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 20 20",
                                            fill: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fillRule: "evenodd",
                                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                                clipRule: "evenodd"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-1 font-medium",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block",
                                                children: "Todos nuestros entrenamientos incluyen la certificaci\xf3n y la insignia digital que se emite gracias a\xa0\xa0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                title: "Asociaci\xf3n Iberoamericana de Scrum AIBES en Credly",
                                                className: "inline-block",
                                                href: "https://www.credly.com/organizations/asociacion-iberoamericana-de-scrum",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    alt: "Credly",
                                                    className: "inline-block",
                                                    src: "credly.webp",
                                                    width: 50
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-1 gap-10 lg:grid-cols-12",
                            children: trainings.map(function(_param) /*#__PURE__*/ {
                                var id = _param.id, training = (0,_object_without_properties/* default */.Z)(_param, [
                                    "id"
                                ]);
                                return (0,jsx_runtime.jsx)("div", {
                                    className: "flex lg:col-span-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainingListingCard, (0,_object_spread/* default */.Z)({}, training))
                                }, "training-listing-".concat(id));
                            })
                        })
                    })
                ]
            })
        ]
    });
};
TrainingListing.defaultProps = defaultProps;
TrainingListing.propTypes = propTypes;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(71070); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);